<template>
  <div class="switch-wrap">
    <div class="circle fc" :class="{ active: value }" :style="style">
      <div class="spot" />
    </div>
    <slot />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const style = computed(() => {
      return {
        marginRight: `${props.gap}px`
      };
    });

    return {
      style
    };
  }
});
</script>

<style scoped lang="less">
.switch-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--border-neutral-color-secondary);
  cursor: pointer;
  margin-right: 4px;
  flex-shrink: 0;
  .spot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  &.active {
    background: var(--theme-color);
    border: 1px solid var(--theme-color);
    .spot {
      background: #fff;
    }
  }
}
</style>
